<template>
  <div class="container">
  <el-row type="flex" justify="center">
    <el-col :lg='18' :md="20" :sm='20' :xs='22' style="text-align: justify">
        <div>
          <h2 style="text-align: center">美钥二维码用户协议</h2>
          <hr>
          <div>
            <h3>一、总则</h3>
            <p>
            1.1 美钥二维码服务所有权及经营权为北京矩石科技有限公司所有。用户在自愿开始使用美钥二维码服务之前，必须仔细阅读并完全接受本协议项下的全部条款。一经注册或激活使用，则视为对本服务全部条款的认知和接受。
            </p>
            <p>
            1.2 用户可通过美钥二维码平台注册用户，用户注册成功后，该用户帐号和密码由用户负责保管。用户只有在接受本协议的情况下，才被允许利用美钥二维码账户及密码登录并获取相关服务。
            </p>
            <p>
            1.3 用户一经注册美钥二维码帐号，除非子频道要求单独开通权限，用户有权利用该账号使用美钥二维码各个频道的单项服务，当用户使用美钥二维码各单项服务时，用户的使用行为视为其对该单项服务的服务条款以及北京矩石科技有限公司在该单项服务中发出的各类公告的同意。
            </p>
            <p>
            1.4 北京矩石科技有限公司有权在必要时修改本服务协议以及各个频道单项服务条款和公告，服务协议及条款一旦发生变动，将会在相关页面上公布修改后的服务条款。如果不同意所改动的内容，用户应主动联系北京矩石科技有限公司工作人员并取消美钥二维码服务。如果用户继续使用美钥二维码服务，则视为接受服务协议及相关条款的变动。
            </p>
          </div>
          <div>
          <h3>二、注册信息和隐私保护</h3>
                <p>2.1  美钥二维码帐号（即美钥二维码用户ID）的所有权归北京矩石科技有限公司所有，用户完成注册申请手续后，获得美钥二维码帐号的使用权。用户应提供及时、详尽及准确的个人资料，并不断更新注册资料，符合及时、详尽准确的要求。所有原始键入的资料将引用为注册资料。如果因注册信息不真实或更新不及时而引发的相关问题，并对问题发生所带来的后果，北京矩石科技有限公司不负任何责任。
                </p>
                <p>
                2.2 美钥二维码帐号只限手机号码和邮箱地址注册。用户应保证注册时所用的手机号码或邮箱地址归本人所有，否则，北京矩石科技有限公司有权终止您的密码、帐号或服务使用，并将您在本服务内任何内容加以移除并删除。
                </p>
                <p>
                2.3 用户不应将其帐号、密码转让、出售或借予他人使用，若用户授权他人使用帐户，应对被授权人在该帐户下发生所有行为负全部责任，并因此产生的任何损失应自行承担。
                </p>
                <p>
                2.4 在如下情况下，北京矩石科技有限公司可能会披露您的信息：
                  <p>（1）事先获得您的授权；</p>
                  <p>（2）您使用共享功能；</p>
                  <p>（3）根据法律、法规、法律程序的要求或政府主管部门的强制性要求；</p>
                  <p>（4）为维护北京矩石科技有限公司的合法权益，例如查找、预防、处理欺诈或安全方面的问题；</p> 
            <p>（5）符合相关服务条款或使用协议的规定。</p>
          </p>
          <p>
          2.5 为更好地向用户提供服务，您同意北京矩石科技有限公司通过短信或邮件等形式向您发送相关商业性服务信息。
          </p>
          </div>
            <div>
              <h3>三、使用规则</h3>
              <p>3.1 用户在使用美钥二维码服务时，必须遵守中华人民共和国相关法律法规的规定，用户应同意将不会利用本服务进行任何违法或不正当的活动，包括但不限于下列行为∶ </p>
                  <p>（1）上载、展示、张贴、传播或以其它方式传送含有下列内容之一的信息：</p>
                  <div style="margin-left: 50px;">
                    <p>1） 反对宪法所确定的基本原则的；</p>
                    <p>2） 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
                    <p>3）  损害国家荣誉和利益的；</p> 
                    <p>4）  煽动民族仇恨、民族歧 视、破坏民族团结的；</p>
                    <p>5）  破坏国家宗教政策，宣扬邪教和封建迷信的；</p> 
                    <p>6）  散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
                    <p>7）  散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
                    <p>8）  侮辱或者诽谤他人，侵害他人合法权利的；</p>
                    <p>9）  含有虚假、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其它道德上令人反感的内容；</p>
                    <p>10）  含有中国法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其它内容的；</p>
                </div>
              <p>（2）不得为任何非法目的而使用美钥二维码平台；</p>
                <p>（3）不利用美钥二维码服务从事以下活动：</p>
                 <div style="margin-left: 50px;"> 
                  <p>1）  未经允许，进入计算机信息网络或者使用计算机信息网络资源的；</p>
                  <p>2）  未经允许，对计算机信息网络功能进行删除、修改或者增加的；</p>
                    <p>3） 未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加的；</p>
                    <p>4）  故意制作、传播计算机病毒等破坏性程序的；</p> 
              <p>5）  其他危害计算机信息网络安全的行为。</p>
              </div>
              <p>3.2 用户违反本协议或相关的服务条款的规定，导致或产生的任何第三方主张的任何索赔、要求或损失，包括合理的律师费，您同意赔偿北京矩石科技有限公司与合作公司、关联公司，并使之免受损害。对此，北京矩石科技有限公司有权视用户的行为性质，采取包括但不限于删除用户发布信息内容、暂停使用许可、终止服务、限制使用、回收美钥二维码帐号、追究法律责任等措施。对恶意注册美钥二维码帐号或利用美钥二维码帐号进行违法活动、捣乱、骚扰、欺骗其他用户以及其他违反本协议的行为，北京矩石科技有限公司有权回收其帐号。同时，北京矩石科技有限公司会视司法部门的要求，协助调查。</p>
              <p>3.3 用户须对自己在使用美钥二维码服务过程中的行为承担法律责任。用户承担法律责任的形式包括但不限于：对受到侵害者进行赔偿，以及在北京矩石科技有限公司首先承担了因用户行为导致的行政处罚或侵权损害赔偿责任后，用户应给予北京矩石科技有限公司等额的赔偿。</p>
            </div>
            <div>
              <h3>四、服务内容</h3>
                <p>4.1 美钥二维码服务的具体内容由北京矩石科技有限公司据实际情况提供。</p>
                <p>4.2 美钥二维码提供的部分服务为收费服务，用户使用收费服务需要向北京矩石科技有限公司支付一定的费用。对于收费服务，本平台会在用户使用之前给予用户明确的提示，只有用户根据提示确认其愿意支付相关费用，用户才能使用该等收费服务。如用户拒绝支付相关费用，则北京矩石科技有限公司有权不向用户提供该收费服务。 </p>
                <p>4.3 美钥二维码仅提供二维码相关服务，除此之外与相关服务有关的设备(如个人电脑、手机、及其他与接入互联网或移动网有关的装置)及所需的费用(如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费)均应由用户自行负担。 </p>
          <p>4.4 北京矩石科技有限公司需要定期或不定期地对提供网络服务的平台或相关的设备进行检修或者维护，如因此类情况而造成网络服务（包括收费网络服务）在合理时间内的中断，北京矩石科技有限公司无需为此承担任何责任。北京矩石科技有限公司保留不经事先通知为维修保养、升级或其它目的暂停本服务任何部分的权利。</p>
          <p>4.5 用户明确同意其使用美钥二维码服务所存在的风险将完全由其自己承担。用户理解并接受通过美钥二维码服务取得的任何信息资料取决于用户自己，并由其承担系统受损、资料丢失以及其它任何风险。北京矩石科技有限公司对在本服务内得到的任何商品购物服务、交易进程、招聘信息，都不作担保。</p> 
                <p>4.6 六个月未登录并且帐号自注册起没有使用任何美钥二维码服务的帐号，北京矩石科技公司保留将该账号关闭的权利。</p>
                <p>4.7 北京矩石科技有限公司有权于任何时间暂时或永久修改或终止本服务（或其任何部分），而无论其通知与否，北京矩石科技有限公司对用户和任何第三人均无需承担任何责任。
                </p>
                <p>4.8 终止服务。您同意北京矩石科技有限公司在您违反本服务协议的文字及精神的前提下，终止您的密码、帐号或本服务之使用（或服务之任何部分）。您同意依本服务协议任何规定提供的服务，无需进行事先通知即可中断或终止。此外，您同意若本服务之使用被中断或终止或您的帐号及相关信息和文件被关闭或删除，北京矩石科技有限公司对您或任何第三人均不承担任何责任。
                </p>
                <p>4.9 为使用本服务，您必须能够自行经有法律资格对您提供互联网接入服务的第三方，进入国际互联网，并应自行支付相关服务费用。此外，您必须自行配备及负责与国际联网连线所需之一切必要装备，包括计算机、数据机或其它存取装置。</p> 
                <p>4.10 不可抗力及免责。您理解并同意，在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务发生中断。  不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。出现上述情况时，北京矩石科技有限公司将努力在第一时间与相关单位配合，及时进行修复，但是由此给您造成的损失，北京矩石科技有限公司在法律允许的范围内免责。
                </p>
                <p>在法律允许的范围内，北京矩石科技有限公司对以下情形导致的服务中断或受阻不承担责任：</p>
            <p>（1）受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏； </p>
            <p>（2）用户或北京矩石科技有限公司的电脑软件、系统、硬件和通信线路出现故障; </p>
            <p>（3）用户操作不当；</p>
            <p>（4）用户通过非北京矩石科技有限公司授权的方式使用本服务；</p>
            <p>（5）其他北京矩石科技有限公司无法控制或合理预见的情形；</p>
            <p>您理解并同意，本服务并非为某些特定目的而设计，包括但不限于核设施、军事用途、 医疗设施、交通通讯等重要领域。如果因为软件或服务的原因导致上述操作失败而带来的人员伤亡、财产损失和环境破坏等，北京矩石科技有限公司不承担法律责任。 </p>
            </div>
            <div>
                <h3>五、知识产权和其他合法权益（包括但不限于名誉权、商誉权）</h3>
                <p>5.1 北京矩石科技有限公司提供的部分服务属于电子公告牌服务。北京矩石科技有限公司不会对您在本服务生成的不违反本协议的任何内容进行移除和删除。 </p>
                <p>5.2 北京矩石科技有限公司拥有本网站内所有资料的版权。任何被授权的浏览、复制、打印和传播属于本网站内的资料必须符合以下条件： </p>
            <p>（1）所有的资料和图象均以获得信息为目的；</p> 
            <p>（2）所有的资料和图象均不得用于商业目的；</p> 
            <p>（3）所有的资料、图象及其任何部分都必须包括此版权声明；</p> 
            <p>（4）本网站（www.meiyaoma.com）所有的产品、技术与所有程序均属于北京矩石科技有限公司的知识产权，在此并未授权。 </p>
                    <p>（5） “meiyaoma”,  “美钥二维码”及相关图形等为北京矩石科技有限公司的注册商标。 </p>
                    <p>（6） 未经北京矩石科技有限公司许可，任何人不得擅自（包括但不限于：以非法的方式复制、传播、展示、镜像、上载、下载）使用。否则，北京矩石科技有限公司将依法追究法律责任。 </p>
                </div>
              <div>
                 <h3>六、用户特别提示</h3>
                    <p>如果您不是具备完全民事权利能力和完全民事行为能力的自然人，您将无权使用美钥二维码服务。 </p>
                </div>
          <div>
                    <h2>七、其他</h2>
                    <p>7.1 本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。 </p>
                    <p>7.2 如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向北京矩石科技有限公司所在地的人民法院提起诉讼。 </p>
                    <p>7.3 北京矩石科技有限公司未行使或执行本服务协议任何权利或规定，不构成对前述权利或权利之放弃。</p>
                    <p>7.4 如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。 </p>
            </div>
        <div>
        <hr/>
        <p>
                    请您在发现任何违反本服务协议以及其他任何单项服务的服务条款、美钥二维码各类公告之情形时，请通知北京矩石科技有限公司。<br>
                  您可以通过如下联络方式同北京矩石科技有限公司联系：<br>
             </p>
                  <address> 
              名称：北京矩石科技有限公司<br> 
              电话：010-82333641<br>
              邮编：100000<br>
              邮箱：jvshikeji@163.com<br>
              地址：北京市海淀区中关村北大街127-1号1层101-22房间<br>
              </address>
        
        </div>
          <hr>
          <p>最后更新于2016年9月14日</p>
        </div>
    </el-col>
  </el-row>
  </div>
</template>
<script type="text/javascript">
import frontHeaderNavigation from '@c/navigation/frontHeaderNavigation.vue'
export default {
  name: 'terms',
  components: {
    frontHeaderNavigation
  }
}
</script>
